import { render, staticRenderFns } from "./ShoesModal.vue?vue&type=template&id=8f7b2cec&"
import script from "./ShoesModal.vue?vue&type=script&lang=js&"
export * from "./ShoesModal.vue?vue&type=script&lang=js&"
import style0 from "./ShoesModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports